const headRowsFreq = {
  name: 'Periodicidad',
  month: 'Intervalo'
};

export default headRowsFreq;
